<template>
    <div class="layout__padding-clear layout__width-100">

        <!--todo maybe add pagination to the search but will have to make an additional call for the csv download-->


        <el-form :model="searchParams" status-icon :rules="{}" ref="searchParams">
            <div class="layout__padding-clear text__align-center layout__width-100">
                <div class="layout__form__customers">
                    <p class="layout__margin__bottom-10">Search</p>
                    <el-form-item prop="freetext">
                        <el-input placeholder="Search" v-model="searchParams.freetext"
                                  clearable
                                  autofocus></el-input>
                    </el-form-item>
                </div>
                <div class="layout__form__customers">
                    <p class="layout__margin__bottom-10">Account Type</p>
                    <el-form ref="status">
                        <el-form-item prop="search">
                            <el-select v-model="searchParams.status" placeholder="Account Type" clearable>
                                <el-option v-for="status in ravensworth.userType.options"
                                           :key="status.id"
                                           :label="status.text"
                                           :value="status.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
            </div>

        </el-form>
        <div class="layout__display-block layout__width-100">
            <el-button class="button-red layout__position-center button__base layout__width-150px" id="getCustomers" v-on:click="getOrders('searchParams')">Search Customers
            </el-button>
        </div>

        <el-button class="layout__display-none" id="getCustomersPagination" v-on:click="getCustomersPagination()">Search Customers
        </el-button>

        <!--<el-button :disabled="this.$parent.customers.length === 0" class="button-teal layout__position-right button__base__admin layout__width-200px" id="downloadAllResults" :loading="downloadLoading" v-on:click="downloadAllResults()">Download Data (csv)-->
        <!--</el-button>-->

        <div class=" layout__position-right layout__padding-5-10">
            <p>{{this.resultsCount}} Results Found</p>
        </div>

    </div>

</template>

<script>

    import Axios from 'axios';
    import {axios} from '@/mixins/Axios.js';
    import {csvDownloadHelper} from '@/mixins/CsvDownloadHelper.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import {backing} from '@/mixins/Backing.js';

    export default {
        name: "adminCustomerSearch",
        mixins: [axios, dataFormatter, backing, csvDownloadHelper],
        props: {
            searchParams: Object,
            customers: Array,
            loading: Boolean,
            resultsCount: String|Number,
        },
        data() {
            return {
                serviceRouteUrl: `${process.env.VUE_APP_ACCOUNTSAPIHOST}`,
                queryOptions: [],
                downloadLoading: false,
                freetextQueryOptions: [],
                resourcePath: '/odata/usersearch',
                queryRouteUrl: `${process.env.VUE_APP_TKGATEWAY}/odata/userSearch?`,
                parameters: [],
                queryConcatAnd: '+and+',
                queryConcatOr: '+or+',
                finalQuery: '',
                territories: [],
                users: [],
                exportDate: new Date().toLocaleDateString('en-GB') + '_users.csv'
            }
        },
        created() {
            this.isUserAuthorised();

            if (window.sessionStorage.getItem('_userSearch') !== null && typeof window.sessionStorage.getItem('_userSearch') !== 'undefined') {
                this.$parent.searchParams = JSON.parse(window.sessionStorage.getItem('_userSearch'))
            } else {
                console.log('not pulling from getItem')
            }

            this.getResults()

            // todo the search works orders pages spec out initial search criteria and pass into here with orders array and the parent gets updated with the results
        },
        beforeUpdate() {
            window.sessionStorage.setItem('_userSearch', JSON.stringify(this.$parent.searchParams));
        },
        methods: {
            constructQueryString() {

                this.queryOptions = []
                this.freetextQueryOptions = []
                this.parameters = []

                let searchTerms = Object.assign({}, this.$parent.searchParams)

                if (searchTerms.freetext !== '') {
                    // this.parameters.push('freetext=' + searchTerms.freetext)

                    this.freetextQueryOptions.push('contains(emailAddress, \'' + searchTerms.freetext + '\')')
                    this.freetextQueryOptions.push('contains(customerRef, \'' + searchTerms.freetext + '\')')
                    this.freetextQueryOptions.push('contains(branchName, \'' + searchTerms.freetext + '\')')
                    this.freetextQueryOptions.push('contains(customerName, \'' + searchTerms.freetext + '\')')
                    this.freetextQueryOptions.push('contains(contact, \'' + searchTerms.freetext + '\')')
                    this.freetextQueryOptions.push('contains(postcode, \'' + searchTerms.freetext + '\')')

                }

                console.log('status of customers')
                console.log(searchTerms.status)
                console.log(searchTerms.status !== '' || searchTerms.status !== null)

                if (searchTerms.status !== null && searchTerms.status !== '') {
                    if (searchTerms.status == 'approval') {
                        this.parameters.push('awaitingApproval+eq+true');
                    } else {
                        this.parameters.push('accountUser+eq+' + searchTerms.status);
                    }
                }

                console.log(this.finalQuery)

                console.log(this.finalQuery.concat('&count=true'))

                console.log('FINISHED METHOD')
            },
            getResults() {

                this.finalQuery = ''

                this.constructQueryString();


                this.returnResults();

                this.returnCounts();
                // let getResults = this.queryRouteUrl;
                //
                //
                // if (this.parameters.length > 0 || this.freetextQueryOptions.length > 0) {
                //     getResults = getResults + '$filter='
                // }
                //
                // if (this.freetextQueryOptions.length > 0) {
                //     getResults = getResults + this.freetextQueryOptions.join('+or+')
                // }
                //
                // if (this.freetextQueryOptions.length > 0 && this.parameters.length > 0) {
                //     getResults = getResults + '+and+'
                // }
                //
                // if (this.parameters.length > 0) {
                //     getResults = getResults + this.parameters.join('+and+')
                // }
                //
                //
                // getResults = getResults + '&$skip=' + this.$parent.searchParams.skip + '&$top=' + this.$parent.searchParams.top;
                //
                //
                // console.log('final query results', getResults)
                //
                // this.$parent.loading = true
                //
                // Axios.get(getResults, this.returnHeaderUsingToken())
                //     .then(response => {
                //         console.log(response)
                //         this.$parent.customers = []
                //         this.$parent.customers = response.data.value
                //
                //         console.log(this.$parent.customers.length)
                //         this.$parent.loading = false
                //     })
                //     .catch(error => {
                //         this.$parent.loading = false
                //         // if (error.response.status === 500) {
                //         this.$parent.customers = []
                //         // }
                //     })




                // let getCounts = this.queryRouteUrl;
                //
                //
                // if (this.parameters.length > 0 || this.freetextQueryOptions.length > 0) {
                //     getCounts = getCounts + '$filter='
                // }
                //
                // if (this.freetextQueryOptions.length > 0) {
                //     getCounts = getCounts + this.freetextQueryOptions.join('+or+')
                // }
                //
                // if (this.freetextQueryOptions.length > 0 && this.parameters.length > 0) {
                //     getCounts = getCounts + '+and+'
                // }
                //
                // if (this.parameters.length > 0) {
                //     getCounts = getCounts + this.parameters.join('+and+')
                // }
                //
                //
                // getCounts = getCounts + '&$count=true&$top=0';
                //
                //
                // console.log('final query counts ', getCounts)
                //
                //
                // Axios.get(getCounts, this.returnHeaderUsingToken())
                //     .then(response => {
                //         console.log(response.data)
                //         console.log(response.data['@odata.count'])
                //         this.$parent.resultsCount = response.data['@odata.count']
                //
                //         // console.log(this.$parent.customers.length)
                //         this.$parent.loading = false
                //     })
                //     .catch(error => {
                //         this.$parent.loading = false
                //         // if (error.response.status === 500) {
                //         // }
                //     })
            },
            returnResults() {
                let getResults = this.queryRouteUrl;


                if (this.parameters.length > 0 || this.freetextQueryOptions.length > 0) {
                    getResults = getResults + '$filter='
                }

                if (this.freetextQueryOptions.length > 0) {
                    getResults = getResults + this.freetextQueryOptions.join('+or+')
                }

                if (this.freetextQueryOptions.length > 0 && this.parameters.length > 0) {
                    getResults = getResults + '+and+'
                }

                if (this.parameters.length > 0) {
                    getResults = getResults + this.parameters.join('+and+')
                }


                getResults = getResults + '&$skip=' + this.$parent.searchParams.skip + '&$top=' + this.$parent.searchParams.top;


                console.log('final query results', getResults)

                this.$parent.loading = true

                Axios.get(getResults, this.returnHeaderUsingToken())
                    .then(response => {
                        console.log(response)
                        this.$parent.customers = []
                        this.$parent.customers = response.data.value

                        console.log(this.$parent.customers.length)
                        this.$parent.loading = false
                    })
                    .catch(error => {
                        this.$parent.loading = false
                        // if (error.response.status === 500) {
                        this.$parent.customers = []
                        // }
                    })
            },
            returnCounts() {
                let getCounts = this.queryRouteUrl;


                if (this.parameters.length > 0 || this.freetextQueryOptions.length > 0) {
                    getCounts = getCounts + '$filter='
                }

                if (this.freetextQueryOptions.length > 0) {
                    getCounts = getCounts + this.freetextQueryOptions.join('+or+')
                }

                if (this.freetextQueryOptions.length > 0 && this.parameters.length > 0) {
                    getCounts = getCounts + '+and+'
                }

                if (this.parameters.length > 0) {
                    getCounts = getCounts + this.parameters.join('+and+')
                }


                getCounts = getCounts + '&$count=true&$top=0';


                console.log('final query counts ', getCounts)


                Axios.get(getCounts, this.returnHeaderUsingToken())
                    .then(response => {
                        console.log(response.data)
                        console.log(response.data['@odata.count'])
                        this.$parent.resultsCount = response.data['@odata.count']

                        // console.log(this.$parent.customers.length)
                        this.$parent.loading = false
                    })
                    .catch(error => {
                        this.$parent.loading = false
                        // if (error.response.status === 500) {
                        // }
                    })
            },
            downloadAllResults() {

                //todo this needs to be cleaned up
                this.downloadLoading = true

                this.constructQueryString()
                // this.$parent.loading = true


                let getResults = this.queryRouteUrl;


                if (this.parameters.length > 0 || this.freetextQueryOptions.length > 0) {
                    getResults = getResults + '$filter='
                }

                if (this.freetextQueryOptions.length > 0) {
                    getResults = getResults + this.freetextQueryOptions.join('+or+')
                }

                if (this.freetextQueryOptions.length > 0 && this.parameters.length > 0) {
                    getResults = getResults + '+and+'
                }

                if (this.parameters.length > 0) {
                    getResults = getResults + this.parameters.join('+and+')
                }

                const downloadAllResultsUri = getResults

                Axios.get(downloadAllResultsUri, this.returnHeaderUsingToken())
                    .then(response => {
                        console.log(response)

                        const fields = [
                            {label: 'Id', value: 'id'},
                            {label: 'Abp_User_Id', value: 'abpUserId'},
                            {label: 'Email_Address', value: 'emailAddress'},
                            {label: 'Import_Source', value: 'pwSource'},
                            {label: 'Branch_Code', value: 'customerRef'},
                            {label: 'Staged_User_Id', value: 'stagedUserId'},
                            {label: 'Customer_Name', value: 'customerName'},
                            {label: 'Account_User', value: 'accountUser'},
                            {label: 'Branch_Name', value: 'branchName'},
                            {label: 'Postcode', value: 'postCode'},
                            {label: 'Phone_Number', value: 'phone'},
                            {label: 'Contact', value: 'contact'},
                            {label: 'Last_Login', value: 'lastLoginTime'},
                        ];

                        this.downloadCsv(this.exportDate, fields, response.data.value)

                        this.downloadLoading = false
                    })
                    .catch(error => {
                        // this.$parent.loading = false

                        // const errorList = ['Unable to process download'];
                        // return errorList;
                        // if (error.response.status === 500) {
                        // this.$parent.customers = []
                        // }
                    })
            },
            getOrders(searchParams) {
                this.$refs[searchParams].validate((valid) => {
                    if (valid) {
                        this.$parent.searchParams.skip = 0;
                        this.$parent.searchParams.currentPage = 1;
                        this.getResults()
                    } else {
                        return false;
                    }
                })
            },
            getCustomersPagination() {
                this.getResults()
            }
        }
    };
</script>